import React, { useState } from 'react';
import { authClient } from '../../auth';

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleGoogle = async () => {
    setLoading(true);
    try {
      await authClient.signIn.social({ provider: 'google', callbackURL: '/' });
    } catch (err) {
      console.error('[Login] Google sign-in failed:', err);
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: '#f9fafb', fontFamily: "'Inter', sans-serif",
    }}>
      <div style={{
        backgroundColor: '#fff', borderRadius: '12px', padding: '48px 40px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '360px', width: '100%',
      }}>
        <h1 style={{ fontFamily: "'Archivo Black', sans-serif", fontSize: '2rem', margin: '0 0 8px 0', color: '#1e293b' }}>
          nicherest
        </h1>
        <p style={{ color: '#64748b', margin: '0 0 32px 0', fontSize: '0.95rem' }}>
          Sign in to your account
        </p>
        <button
          onClick={handleGoogle}
          disabled={loading}
          style={{
            width: '100%', padding: '12px 20px', borderRadius: '8px',
            border: '1px solid #e2e8f0', backgroundColor: '#fff', cursor: loading ? 'not-allowed' : 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
            fontSize: '0.95rem', fontWeight: 500, color: '#1e293b',
            opacity: loading ? 0.7 : 1, transition: 'background-color 0.15s',
          }}
          onMouseEnter={e => { if (!loading) e.currentTarget.style.backgroundColor = '#f8fafc'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
            <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
          </svg>
          {loading ? 'Signing in…' : 'Continue with Google'}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
